import compileSymbols from '~/utils/compileSymbols';

const types = [
  'FETCH_STYLE',
  'STYLE_LOADED',
  'STYLE_LOAD_ERROR',
  'FETCH_STYLES',
  'SET_OVERLAY_STYLES',
  'STYLES_SUCCESS',
  'STYLES_ERROR',
  'LOAD_CATALOG_DESIGN'
];

export default compileSymbols(types, 'catalog');
